import React, { useState } from "react"; //type rfc for functional component

export default function TextForm(props) {
  const handleUpClick = () => {
    console.log("UppeerCase was clicked" + text);
    let newText = text.toUpperCase(); // to upper case
    setText(newText);
    props.showAlert("converted to uppercase","success");
  };
  const handleDownClick = () => {
    console.log("lowercase was clicked" + text);
    let newText = text.toLowerCase(); //to lowercase
    setText(newText);
    props.showAlert("converted to lowewrcase","success");
  };
  const speak = () => {
    let msg = new SpeechSynthesisUtterance();
    msg.text = text;
    window.speechSynthesis.speak(msg);
    //to speak
    props.showAlert("text translated into voice ","success");
  };
  const handleTiClick = () => {
    // console.log("Title case was clicked" + text);
    let newText = ""; //clear text
    setText(newText);
    props.showAlert("text cleared","success");
  };
  const handleAltClick = () => {
    // console.log("Alt case was clicked" + text);
    //reverse sring
    let newText = text.split(" ").reverse().join(" ");
    setText(newText);
    props.showAlert("text reversed","success");
    
  };
  
  const handleCopy = () => {
    var text = document.getElementById("myBox");
    text.select();
    navigator.clipboard.writeText(text.value);
    props.showAlert("text copied","success");
  };
  const handleOnCHange = (event) => {
    // console.log("on chnage" );
    setText(event.target.value);
  };
  const [text, setText] = useState(""); //[current state, update state]
  // setText("abcdef") //correct way to change state

  const buttonStyle = {
    light: {
      backgroundColor: "",
      color: ""
    },
    dark: {
      backgroundColor: "green",
      color: "#f0f0f0"
    },red:{
      backgroundColor: "red",
      color: "#f0f0f0"
    },blue:{
      backgroundColor: "#191970",
      color: "#f0f0f0"
    }
  };
  return (
    <>
      <div
        className="container"
        style={{ color: props.mode === "dark" ? "white" : props.mode === "red" ? "white" : props.mode === "blue" ? "white" : "black" }}

      >
        {/* use of props */}
        <h1 className="mb-4">{props.heading} </h1>
        <div className="mb-3">
          <textarea
            className="form-control"
            value={text}
            onChange={handleOnCHange}
            style={
              buttonStyle[props.mode]
            }
            id="myBox"
            rows="10"
            cols="8"
          ></textarea>
        </div>
        <button disabled={text.length===0} className="btn btn-primary " onClick={handleUpClick}  style={buttonStyle[props.mode]}>
          UpperCase{" "}
        </button>{" "}
        &nbsp;
        {/* &nbsp; for space betwwen two buttons  can use mx-2*/}
        <button  disabled={text.length===0}className="btn btn-secondary mx-2  my-2" onClick={handleDownClick}  style={buttonStyle[props.mode]}>
          lowercase
        </button>
        <button disabled={text.length===0} className="btn btn-success mx-2 my-2 " onClick={handleAltClick}  style={buttonStyle[props.mode]}>
          Reverse
        </button>
        <button  disabled={text.length===0}className="btn btn-warning mx-2 my-2  text-light" onClick={speak}  style={buttonStyle[props.mode]}>
          Speak
        </button>
        <button disabled={text.length===0} className="btn btn-danger mx-2  my-2" onClick={handleTiClick} style={buttonStyle[props.mode]}>
          Clear
        </button>
        <button  disabled={text.length===0}className="btn btn-danger mx-2  my-2" onClick={handleCopy} style={buttonStyle[props.mode]}>
          Copy
        </button>
      </div>
      <div
        className="container my-3"
        style={{ color: props.mode === "dark" ? "white" : props.mode === "red" ? "white" : props.mode === "blue" ? "white" : "black" }}

      >
        <h3>Text Summary</h3>
        <p>
          {text.split(" ").filter((element)=>{return element.length!==0}).length}words and {text.length} characters
        </p>
        {/* text === "" ? 0 :   to start from 0 word */}
        <p> It takes {0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length}minutes </p>
        <h3>Preview</h3>
        <p>{text.length > 0 ? text : "mothing to previw"}</p>
      </div>
    </>
  );
}